export default __webpack_public_path__ + "static/media/right-post.00bee6f3.svg";